// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Container,
  Row,
  UncontrolledTooltip,
  Label,
  Form,
  FormGroup,
  Input,
  CardBody,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import { EXPENSE,PAYMENT_ACCOUNT_API } from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
} from "../../services/apiServices";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { bindNiceSelect } from "utils/NiceSelectUtils";
import '../../utils/NiceSelect.css'
import { DataTable, FilterBar } from "components/shared";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "amount", label: "Amount" },
  { key: "type", label: "Type" },
  { key: "account", label: "Account" },
  { key: "date", label: "Date" },
  { key: "remark", label: "Remark" },
];

const Expense = () => {
  // new NiceSelect(document.getElementById("a-select"), {searchable: true});

  const history = useHistory();
  const [expenses, setExpenses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [amount, setAmount] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [payment_account_id, setPaymentAccountId] = useState("");
  const [paymentAccounts, setPaymentAccounts] = useState([]);
  console.log(payment_account_id)

  const [startDate, setStartDate] = useState(
    moment().startOf("day").toISOString()
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").toISOString());

  useEffect(() => {
    if(paymentAccounts.length > 0){
      const el = document.getElementById('a-select');
      bindNiceSelect(el);
    }
  }, [paymentAccounts]);

  useEffect(() => {
    setDate(moment().format("YYYY-MM-DD"));
    setType("refund");
    fetchExpenses();
    fetchPaymentAccounts();
  }, [startDate, endDate]);

  let fetchExpenses = () => {
    setIsLoading(true);
    getApiDataService(EXPENSE + `?start_date=${startDate}&end_date=${endDate}`)
      .then((res) => {
        console.log("res.data=", res.data);
        setExpenses(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setExpenses([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetchPaymentAccounts = () => {
    getApiDataService(PAYMENT_ACCOUNT_API)
      .then((res) => {
        console.log("res.data=", res.data);
        setPaymentAccounts(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  }

  let handleExpenseDateChange = (start, end, label) => {
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());
  };

  let handleSave = () => {
    let data = {
      amount,
      type,
      date,
      remark,
      payment_account_id
    };
    setBtnLoading(true);
    postApiDataService(EXPENSE, data)
      .then((res) => {
        console.log("res.data=", res.data);
        setBtnLoading(false);
        fetchExpenses();
        setAmount("");
        setType("");
        setRemark("");
        setPaymentAccountId("");
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setBtnLoading(false);
      });
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col-4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add Expense</h3>
              </CardHeader>
              <CardBody>
                <Form>
                  <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Input
                      type="number"
                      name="amount"
                      id="amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="type">Type</Label>
                    <Input
                      type="select"
                      name="type"
                      id="type"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="refund">Refund</option>
                      <option value="salary">Salary</option>
                      <option value="others">Others</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="payment_account_id">Payment Account</Label>
                    <select className='form-control sampleClass' id="a-select" placeholder="Select Payment Account" value={payment_account_id} onChange={(e) => setPaymentAccountId(e.target.value)}>
                        {paymentAccounts.map((item, index) => (
                          //<img src={item.payment_provider.logo}></img>
                          <option key={index} value={item.id}>{item.payment_provider.name} - {item.account_name} ({item.account_no})</option>
                        ))}
                    </select>

                    {/* <Input type="select" name="payment_account_id" id="payment_account_id" value={payment_account_id} onChange={(e) => setPaymentAccountId(e.target.value)}>
                      
                      </Input> */}
                  </FormGroup>
                  <FormGroup>
                    <Label for="date">Date</Label>
                    <Input
                      type="date"
                      name="date"
                      id="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="remark">Remark</Label>
                    <Input
                      type="textarea"
                      name="remark"
                      id="remark"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter className="text-right">
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={btnLoading}
                >
                  {btnLoading ? "Saving..." : "Save"}
                </button>
              </CardFooter>
            </Card>
          </div>
          <div className="col-8">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="Expense Lists">
                  <DateRangePicker onCallback={handleExpenseDateChange}>
                    <input
                      style={{ width: "200px" }}
                      className="form-control"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>
                </FilterBar>
              </CardHeader>
              <DataTable
                columns={COLUMNS}
                data={expenses}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(item, index) => (
                  <tr key={item?.id ?? index}>
                    <td>{index + 1}</td>
                    <td className="font-mono">
                      {item.amount.toLocaleString("en-US")}
                    </td>
                    <td>{item.type}</td>
                    <th scope="row">
                      <Media className="align-items-center">
                        <a
                          className=" rounded-circle mr-3"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <img
                            alt="..."
                            src={item?.payment_account?.payment_provider?.logo}
                            style={{ width: "40px" }}
                          />
                        </a>
                        <Media>
                          <span className="mb-0 text-sm">
                            {item?.payment_account?.payment_provider?.name}
                          </span>
                          <span className="mb-0 text-sm">
                            ( {item?.payment_account?.account_no} )
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{moment(item.date).format("YYYY-MM-DD")}</td>
                    <td>{item.remark}</td>
                  </tr>
                )}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Expense;
